<template>
  <!--
    NoteDialog.vue
    Dialog for adding notes to a user.
    Includes a tooltip, confirmation dialog, and loading state.
  -->
  <div>
    <!-- Tooltip and activator for the note action -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-list-item v-bind="attrs" v-on="on" @click="dialog = true">
          <v-list-item-title class="primary--text">
            <v-icon color="primary" class="mr-2">mdi-note-plus-outline</v-icon>
            <span>Note</span>
          </v-list-item-title>
        </v-list-item>
      </template>
      <span>Add notes to this user</span>
    </v-tooltip>

    <!-- Add note dialog -->
    <v-dialog v-model="dialog" :persistent="isLoading" width="500">
      <v-card :loading="isLoading">
        <v-card-title>Add Notes</v-card-title>
        <v-card-text>
          <v-form ref="noteForm" v-model="noteFormIsValid">
            <v-textarea v-model="content" :rules="contentRules" outlined name="input-7-4" label="Content"></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <v-btn outlined :disabled="isLoading" @click="dialog = false">Cancel</v-btn>
          <v-btn color="primary" :loading="isLoading" @click="submitForm()">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// NoteDialog.vue: dialog for adding notes to a user
import { mapActions } from 'vuex';
import { SET_RESPONSE_DIALOG } from '@/shared/mutations/type';

export default {
  name: 'NoteDialog',
  props: {
    /**
     * User ID to add note to
     */
    userId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      // Loading state for dialog actions
      isLoading: false,
      // Dialog visibility
      dialog: false,
      // Form validation state
      noteFormIsValid: true,
      // Validation rules for note textarea
      contentRules: [(v) => !!v || 'This field is required', (v) => v.length < 501 || 'Maximum of 500 characters'],
      // Note content
      content: '',
    };
  },
  methods: {
    // Map Vuex action for adding note
    ...mapActions(['addNoteAction']),
    /**
     * Submit note form and show response dialog
     */
    async submitForm() {
      if (!this.$refs.noteForm.validate()) return;
      this.isLoading = true;
      const response = await this.addNoteAction({ userId: this.userId, content: this.content });

      if (response) {
        this.$store.commit(`${SET_RESPONSE_DIALOG}`, {
          visible: true,
          isSuccess: true,
          message: 'Success',
          subMessage: null,
          errors: [],
        });

        this.content = '';
        this.dialog = false;
      } else {
        this.dialog = true;
      }

      this.isLoading = false;
    },
  },
};
</script>
